<!--
component: PlotMap
author: Ken Nakamura
description: プロット地図画面
-->
<template>
  <section class="plot-map">
    <div class="split">
      <div class="split left-box">
        <ImageCanvas id="image-viewer"
          width="100%" height="100%"
          :imageUrl="imageUrl"
          :imageScale="imageScale"
          v-if="useCanvas" />
        <ImageViewer :imageUrl="imageUrl"
          :scaleSize="scaleSizeReset"
          @updateScaleSize="scaleSize = $event"
          width="100%" height="100%"
          v-else />
      </div>
      <div class="split right-box">
        <v-container fluid>
          <v-row  mt-1 mb-2 ml-1 mr-0 pb-2 pl-2 pr-0 v-show="mode==1">
            <v-col cols="6" class="mx-0 px-0"
              style="margin:0px 0px !important; padding: 1px 2px !important;"
              v-for="(nendo, index) in nendoList" :key="index">
              <v-btn @click="selectNendo(nendo)" width="95%"
                class="text-h7"
                :class="`color-${nendo.color}${nendoYear==nendo.year?'-active':''}`"
                style="margin:1px 1px !important;" >
                {{nendo.caption}}
              </v-btn>
            </v-col>
          </v-row>
          <v-row class="justify-center">
            <tenkey-pad @pushed="tenkeyPushed" @clear="clearNo" />
          </v-row>
          <v-row v-show="mode==1">
            <v-col cols="6">
              <v-btn-toggle v-model="inputMode" mandatory background-color="white">
                <v-btn active-class="light-blue darken-3 white--text">図郭</v-btn>
                <v-btn active-class="light-blue darken-3 white--text">受付番号</v-btn>
              </v-btn-toggle>
            </v-col>
            <v-col cols="1"></v-col>
            <v-col>
              <v-text-field id="text-bango" v-model="bango" ref="bangoText"
                solo type="tel" autocomplete="off" hide-details="auto"
                @keyup="checkChar"
                class="text-h6"
              />
            </v-col>
          </v-row>
          <v-row v-show="mode==5" dense class="mt-4">
            <v-col cols="6">
              <v-btn-toggle v-model="gengoIndex"
                dense mandatory background-color="white">
                <v-btn active-class="light-blue darken-3 white--text"
                  @click="kaihatsuInputMode=0">
                  昭和
                </v-btn>
                <v-btn active-class="light-blue darken-3 white--text"
                  @click="kaihatsuInputMode=0">
                  平成
                </v-btn>
              </v-btn-toggle>
            </v-col>
            <v-col>
              <v-text-field id="text-nendo" v-model="nendoYear" ref="nendo"
                solo type="tel" autocomplete="off" hide-details="auto"
                @keyup="checkChar"
                @click="kaihatsuInputMode=0"
                :background-color="kaihatsuInputColor(0)"
                class="text-h6" dense
              />
            </v-col>
          </v-row>
          <v-row v-show="mode==1" class="my-1" dense>
            <v-btn color="#4063a3" height="1.6em"
              class="search-btn"
              :disabled="!browsable"
              @click="browse"
            >{{browseButtonTitle}}
            </v-btn>
          </v-row>
          <v-row v-show="mode==5" class="my-1" dense>
            <v-col cols=5 class="px-1 py-0">
              <v-btn color="#5dabbe"
                class="page-btn my-1"
                @click="kaihatsuInputMode=1">
                番号
              </v-btn>
            </v-col>
            <v-col class="py-1 pl-5 pr-1">
              <v-text-field id="bango" v-model="bango" ref="bango"
                solo type="tel" autocomplete="off" hide-details="auto"
                @keyup="checkChar"
                @click="kaihatsuInputMode=1"
                :background-color="kaihatsuInputColor(1)"
                class="text-h6" dense
              />
            </v-col>
          </v-row>
          <v-row v-show="mode==5" dense>
            <v-col class="py-1" cols="5">
              <v-btn-toggle v-model="targetType"
                dense mandatory background-color="white">
                <v-btn active-class="light-blue darken-3 white--text">開発</v-btn>
                <v-btn active-class="light-blue darken-3 white--text">宅造</v-btn>
              </v-btn-toggle>
            </v-col>
            <v-col class="py-1">
              <v-btn color="#4063a3"
                class="search-btn my-0"
                :disabled="!browsable"
                @click="browse">
                {{btnTitle}}
              </v-btn>
            </v-col>
          </v-row>
          <v-row v-show="mode==5" class="my-1" dense>
            <v-col cols=4 class="px-1 py-0">
              <v-btn color="#5dabbe"
                class="page-btn my-1"
                @click="kaihatsuInputMode=2">
                図郭
              </v-btn>
            </v-col>
            <v-col cols=4 class="px-0 py-1">
              <v-text-field id="text-sheet" v-model="sheetNo" ref="sheet"
                solo autocomplete="off" hide-details="auto"
                @keyup="checkChar"
                @click="kaihatsuInputMode=2"
                :background-color="kaihatsuInputColor(2)"
                dense
                class="text-h7 mx-1 my-0"
              />
            </v-col>
            <v-col cols=4 class="px-1 py-0">
              <v-btn color="#5dabbe"
                class="page-btn my-1"
                :disabled="!sheetNo"
                @click="changeSheet">
                変更
              </v-btn>
            </v-col>
          </v-row>
          <v-row class="my-1" dense>
            <v-col cols=6 class="px-1 py-0">
              <v-btn color="#5dabbe"
                class="page-btn my-1"
                :disabled="pageNo<1"
                @click="prevPage">
                <v-icon color="#dddddd" class="mx-1">mdi-step-backward</v-icon>
                前ページ
              </v-btn>
            </v-col>
            <v-col cols=6 class="px-1 py-0">
              <v-btn color="#5dabbe"
                class="page-btn my-1"
                @click="nextPage">
                <v-icon color="#dddddd" class="mx-1">mdi-step-forward</v-icon>
                次ページ
              </v-btn>
            </v-col>
          </v-row>
          <v-row class="my-1" dense>
            <v-col cols=4 class="px-0 py-0">
              <v-btn color="#5dabbe"
                class="page-btn mx-0 my-1"
                @click="zoomIn">
                <v-icon color="#dddddd" class="ma-auto">mdi-plus-circle</v-icon>
                拡大
              </v-btn>
            </v-col>
            <v-col cols=4 class="px-0 py-0">
              <v-btn color="#5dabbe"
                class="page-btn mx-0 my-1"
                @click="zoomOut">
                <v-icon color="#dddddd" class="ma-auto">mdi-minus-circle</v-icon>
                縮小
              </v-btn>
            </v-col>
            <v-col cols=4 class="px-0 py-0">
              <v-btn color="#5dabbe" width="100%"
                class="page-btn mx-0 my-1"
                @click="zoomEntire">
                <v-icon small color="#dddddd" class="ma-auto">mdi-arrow-expand-all</v-icon>
                全体表示
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </div>
    <Dialog search :open="searching" :cancel="cancelSearch" title="検索中" />
    <Dialog message :open="canceled" :ok="closeDialog"
      title="番号検索" body="キャンセルされました" />
    <Dialog error :open="notfound" :close="closeDialog"
      :title="errorTitle" :body="errorMessage" />
  </section>
</template>

<script>
import ImageViewer from '../components/ImageViewer.vue';
import ImageCanvas from '../components/ImageCanvas.vue';
import TenkeyPad from '../components/TenkeyPad.vue'
import Dialog from '../components/Dialog.vue'
import { loadKenkakuPlot, loadKaihatsuPlot } from '../common/apiAccess.js'
import { dbglog, yearToNendo } from '../common/utils.js';
import { searchGaiyo, findKaihatsu, findTakuzo } from '../common/apiAccess.js'

export default {
  components: {
    ImageViewer,
    ImageCanvas,
    TenkeyPad,
    Dialog,
  },
  data() {
    return {
      pages: [],
      pageNo: -1,
      sheetNo: '',
      nendoList: [],
      nendo: '',
      gengoIndex: 0,
      targetType: 0,
      inputMode: 1,
      kaihatsuInputMode: 0,
      scaleSize: 1,
      searching: false,
      notfound: false,
      canceled: false,
      errorTitle: '番号検索',
      errorMessage: '指定された番号が見つかりません',
      controller: null,
      useCanvas: true,
      imageScale: 1,  // ImageCanvasに渡す画像拡大率（画面横幅いっぱいを1とする）
    }
  },
  props: {
    sheet: {
      type: Number,
      default: -1,
    },
  },
  watch: {
    sheetNo: {
      immediate: true,
      handler(val) {
        if (val) {
          val = parseInt(val);
          if (Number.isNaN(val) || val <= 0) {
            val = '';
          }
          this.$refs.sheet.lazyValue = val;
          this.sheetNo = val;
        }
      }
    },
  },
  mounted () {
    if (this.unauthorized) {
      this.message = 'ユーザー認証されていません。';
      this.$router.replace('/');
      return;
    }
    this.gengoIndex = this.$store.state.searchEra;
    this.targetType = this.$store.state.searchTargetType;
    
    this.loading = true;
    dbglog(`PlotIndex.mounted: sheetNo = ${this.sheet} indexId = ${this.indexId}`);
    if (this.mode == 1) {
      this.message = '建築確認申請プロット地図検索 : ' + this.wardName;
      loadKenkakuPlot(this.indexId, (data) => {
        this.pages = data.pages;
        this.nendoList = data.nendoList;
        if (this.sheet > 0) {
          this.plotPage = this.sheet;
        }
        else {
          this.pageNo = this.sheetToPageIndex(this.plotPage)
        }
        this.loading = false;
        this.updateMessage();
      })
    }
    else if (this.mode == 5 || this.mode == 6) {
      dbglog(`PlotIndex.mounted: sheetNo = ${this.sheet} indexId = ${this.indexId}`);
      this.message = '開発・造成・土石の堆積プロット地図検索 : ' + this.wardName;
      loadKaihatsuPlot(this.indexId, (data) => {
        this.pages = data.pages;
        this.nendoList = data.nendoList;
        if (this.sheet > 0) {
          this.plotPage = this.sheet;
        }
        else {
          this.pageNo = this.sheetToPageIndex(this.plotPage)
        }
        this.loading = false;
        this.updateMessage();
        dbglog(`PlotIndex.mounted: page count = ${this.pages.length}`);
        dbglog(this.pages[0])
      })
    }
    if (this.pageNo < 0) {
      this.pageNo = 0;
    }
  },
  computed: {
    token () {
      return this.$store.state.token;
    },
    unauthorized () {
      return this.token == undefined || this.token == null || this.token.length == 0;
    },
    authorized () {
      return !this.unauthorized;
    },
    mode () {
      return this.$store.state.mode;
    },
    browseButtonTitle () {
      return this.inputMode == 0 ? 'プロット地図表示' : '概要書閲覧'
    },
    wardCode () {
      return this.$store.state.wardCode;
    },
    wardName () {
      return this.$store.state.wardName;
    },
    indexId () {
      return this.$store.state.indexId;
    },
    nendoName: {
      get() { return this.$store.state.nendoName; },
    },
    nendoYear: {
      get() { return this.$store.state.searchYear; },
      set(val) {
        val = parseInt(val);
        if (Number.isNaN(val) || val <= 0) {
          val = '';
        }
        this.$refs.nendo.lazyValue = val;
        this.$store.commit('setSearchYear', val); 
      }
    },
    bango: {
      get() { return this.$store.state.searchBango;},
      set(val) {
        val = parseInt(val);
        if (Number.isNaN(val) || val <= 0) {
          val = '';
        }

        this.mode == 1 ? this.$refs.bangoText.lazyValue = val : this.$refs.bango.lazyValue = val;
        this.$store.commit('setSearchBango', val);
      }
    },
    btnTitle() {
      //return this.targetType == 0 ? '開発登録簿閲覧' : '宅造図面閲覧';
      return '閲覧';
    },
    plotPage: {
      get() { return this.$store.state.plotPage; },
      set(val) {
        const pageNo = this.sheetToPageIndex(val);
        if (pageNo >= 0) {
          this.$store.commit('setPlotPage', val);
          this.pageNo = pageNo;
        }
        else {
          this.errorTitle = 'プロット地図表示';
          this.errorMessage = '指定された図郭番号のプロット地図がありません。';
          this.notfound = true;
        }
      }
    },
    imageUrl () {
      if (this.pages === undefined || this.pages === null || this.pages.length === undefined) {
        return '';
      }
      if (this.pageNo < 0 || this.pageNo >= this.pages.length) {
        return '';
      }
      const page = this.pages[this.pageNo];
      dbglog(`PlotMap.imageUrl: page no = ${this.pageNo}`);
      if (page === null || page === undefined) {
        return '';
      }
      dbglog(page);
      dbglog(page.fileName);
      let origin = '';
      if (this.mode == 1) {
        origin = this.$store.state.kenkakuPlotImgOrigin;
      }
      else if (this.mode == 5 || this.mode == 6) {
        origin = this.$store.state.kaihatsuPlotImgOrigin;
      }
      let url = origin + page.fileName;
      if (origin.length > 0 && !origin.endsWith('/') && !page.fileName.startsWith('/')) {
        url = origin + '/' + page.fileName;
      }
      dbglog(url);
      return url;
    },
    scaleSizeReset() {
      return this.scaleSize;
    },
    message: {
      get() { return this.$store.state.message; },
      set(val) { this.$store.commit('setMessage', val) }
    },
    browsable() {
      return (this.inputMode == 0 && this.bango > 0)
          || (this.inputMode == 1 && this.nendoYear > 0 && this.bango > 0);
    },
  },
  methods: {
    kaihatsuInputColor(n) {
      return (n == this.kaihatsuInputMode) ? 'yellow' : 'white';
    },
    tenkeyPushed(n) {
      if (this.mode == 5) {
        if (this.kaihatsuInputMode == 0) {
          if (this.nendoYear) {
            this.nendoYear = this.nendoYear * 10 + n;
          }
          else {
            this.nendoYear = n;
          }
        }
        else if (this.kaihatsuInputMode == 1) {
          if (this.bango) {
            this.bango = this.bango * 10 + n;
          }
          else {
            this.bango = n;
          }
        }
        else if (this.kaihatsuInputMode == 2) {
          if (this.sheetNo) {
            this.sheetNo = this.sheetNo * 10 + n;
          }
          else {
            this.sheetNo = n;
          }
        }
      }
      else {
        if (this.bango === null || isNaN(this.bango) || this.bango == '') {
          this.bango = n;
        }
        else {
          this.bango = this.bango * 10 + n;
        }
      }
    },
    clearNo() {
      if (this.mode == 5) {
        if (this.kaihatsuInputMode == 0) {
          this.nendoYear = '';
        }
        else if (this.kaihatsuInputMode == 1) {
          this.bango = '';
        }
        else if (this.kaihatsuInputMode == 2) {
          this.sheetNo = '';
        }
      }
      else {
        this.bango = '';
      }
    },
    checkChar () {
      if (this.bango.length) {
        this.bango = this.bango.replace(/[^0-9]/g, '');
      }
    },
    sheetToPageIndex (sheetNo) {
      if (this.pages === null || this.pages.length === undefined) {
        return -1;
      }
      for (let i = 0; i < this.pages.length; i++) {
        const page = this.pages[i];
        if (page.pageNo == sheetNo) {
          return i;
        }
      }
      return -1;
    },
    selectNendo (nendo) {
      this.nendo = nendo.caption;
      this.nendoYear = nendo.year;
    },
    updateMessage () {
      let pageName = this.plotPage;
      const page = this.pages[this.pageNo];
      if (page) {
        pageName = `${page.pageNo}`;
        if (page.branch) {
          pageName += '-' + page.branch;
        }
      }
      if (this.mode == 1) {
        //this.message = `建築確認申請プロット地図【${this.wardName} ${this.nendoName}】ページ ${this.plotPage}`;
        this.message = `建築確認申請プロット地図【${this.wardName} ${this.nendoName}】ページ ${pageName}`;
      }
      else if (this.mode == 5 || this.mode == 6) {
        //this.message = `開発・造成・土石の堆積プロット地図【${this.wardName} ${this.nendoName}】ページ ${this.plotPage}`;
        this.message = `開発・造成・土石の堆積プロット地図【${this.wardName} ${this.nendoName}】ページ ${pageName}`;
      }
      else {
        this.message = '';
      }
    },
    browse () {
      this.$store.commit('setSearchEra', this.gengoIndex);
      this.$store.commit('setSearchTargetType', this.targetType);
      if (this.inputMode == 0) {
        this.plotPage = this.bango;
        this.updateMessage();
      }
      else if (this.mode == 1) {
        //建築計画概要書閲覧
        let nendoText = yearToNendo(this.nendoYear, 4);
        nendoText = nendoText.substring(0, nendoText.length - 1);
        this.searching = true;
        this.controller = searchGaiyo(nendoText, this.wardName, this.bango, (data) => {
          this.searching = false;
          if (data.length !== undefined && data.length > 0) {
            if (data.length == 1 && data[0].daichoId !== undefined) {
              this.$store.commit('setGaiyoId', data[0].daichoId);
              this.$router.push({ name: 'loading', params: { action: 4 }});
            }
            else {
              this.$store.commit('setSummaries', data);
              this.$router.push({ name: 'list-result', params: { listId: 0 }});
            }
          }
          else {
            this.errorTitle = '概要書閲覧';
            this.errorMessage = '該当する概要書が見つかりません。';
            this.notfound = true;
          }
        });
      }
      else if (this.mode == 5 || this.mode == 6) {
        const gengo = this.gengoIndex == 0 ? 'S' : 'H';
        //const gengo = 'H';
        if (this.targetType == 0) {
          // 開発登録簿閲覧
          this.searching = true;
          this.contoroller = findKaihatsu(gengo, this.nendoYear, this.wardCode, this.bango,
          (data) => {
            this.searching = false;
            if (data.length !== undefined && data.length > 0 && data[0].id !== undefined) {
              this.$router.push({name:'browse-kaihatsu', params:{id: data[0].id, target:0}});
            }
            else {
              this.errorTitle = '開発登録簿閲覧';
              this.errorMessage = '該当する開発登録簿が見つかりません。';
              this.notfound = true;
            }
          });
        }
        else if (this.targetType == 1) {
          // 宅造閲覧
          this.searching = true;
          // searchNo.vueとの干渉を防ぐため、kaihatsuTypeをnullにする
          const targetKaihatsuType = null;
          this.contoroller = findTakuzo(gengo, this.nendoYear, this.wardCode, this.bango, targetKaihatsuType,
          (data) => {
            this.searching = false;
            if (data.length !== undefined && data.length > 0 && data[0].id !== undefined) {
              this.$router.push({name:'browse-kaihatsu', params:{id:data[0].id, target:1}});
            }
            else {
              this.errorTitle = '宅造図面閲覧';
              this.errorMessage = '該当する宅造データが見つかりません。';
              this.notfound = true;
            }
          });
        }
      }
    },
    changeSheet() {
      this.plotPage = Number(this.sheetNo);
      this.updateMessage();
    },
    prevPage() {
      //this.plotPage = Number(this.plotPage) - 1;
      //test
      this.pageNo--;
      this.updateMessage();
    },
    nextPage() {
      //this.plotPage = Number(this.plotPage) + 1;
      //test
      this.pageNo++;
      this.updateMessage();
    },
    zoomIn () {
      if(this.scaleSize < 10){
        this.scaleSize += 1;
      }
      this.imageScale *= 1.5;
    },
    zoomOut () {
      if(this.scaleSize > 1){
        this.scaleSize -= 1;
      }
      if (this.imageScale > 1) {
        this.imageScale = Math.max(1, this.imageScale / 1.5);
      }
    },
    zoomEntire() {
      if (this.useCanvas) {
        this.imageScale = 1;
      }
      else {
        this.scaleSize = 1;
      }
    },
    cancelSearch() {
      if (this.contoroller !== null) {
        this.controller.abort();
      }
      this.searching = false;
      this.canceled = true;
    },
    closeDialog() {
      this.searching = false;
      this.notfound = false;
      this.canceled = false;
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/common/common.css";
@import "../styles/split-alt.css";
.split {
  position: absolute;
  width: 100%;
  height: calc(100% - 13px);
  padding: 6px 0;
  margin: 0;
}
.left-box {
  left: 0;
  width: calc(100% - 300px);
  overflow: hidden;
  margin: 0;
  padding: 0;
}
.right-box {
  right: 0;
  width: 300px;
  background-color: rgb(162, 235, 245);
  //padding-bottom: 20px;
  overflow: auto;
}

.color-0 {
  color: black;
  font-weight: 600;
}
.color-1 {
  color: red;
  font-weight: 600;
}
.color-2 {
  color: green;
  font-weight: 600;
}
.color-3 {
  color: #c0c000;
  font-weight: 600;
}
.color-4 {
  color: blue;
  font-weight: 600;
}
.color-5 {
  color: magenta;
  font-weight: 600;
}
.color-6 {
  color: cyan;
  font-weight: 600;
}
.color-7 {
  color: #606060;
  font-weight: 600;
}
.color-8 {
  color: #ff8080;
  font-weight: 600;
}
.color-9 {
  color: #8000ff;
  font-weight: 600;
}
.color-10 {
  color: rgb(230,121,40);
  font-weight: 600;
}
.color-11 {
  color: #ff80ff;
  font-weight: 600;
}

.color-0-active {
  color: black;
  background-color: yellow !important;
  font-weight: 600;
}
.color-1-active {
  color: red;
  background-color: yellow !important;
  font-weight: 600;
}
.color-2-active {
  color: green;
  background-color: yellow !important;
  font-weight: 600;
}
.color-3-active {
  color: #a0a000;
  background-color: yellow !important;
  font-weight: 600;
}
.color-4-active {
  color: blue;
  background-color: yellow !important;
  font-weight: 600;
}
.color-5-active {
  color: magenta;
  background-color: yellow !important;
  font-weight: 600;
}
.color-6-active {
  color: cyan;
  background-color: yellow !important;
  font-weight: 600;
}
.color-7-active {
  color: #606060;
  background-color: yellow !important;
  font-weight: 600;
}
.color-8-active {
  color: #ff8080;
  background-color: yellow !important;
  font-weight: 600;
}
.color-9-active {
  color: #8000ff;
  background-color: yellow !important;
  font-weight: 600;
}
.color-10-active {
  color: rgb(230,121,40);
  background-color: yellow !important;
  font-weight: 600;
}
.color-11-active {
  color: #ff80ff;
  background-color: yellow !important;
  font-weight: 600;
}

.yellow {
  background-color: yellow !important;
}

.search-btn {
  border-radius: 5px;
  border: 0px;
  background-color: #4063a3;
  margin: 10px;
  padding: 10em;
  font-weight: 400;
  text-align: center;
  text-decoration: none;
  color: #cbe7e5;
  font-size: 1.4em;
  user-select: none;
  width: 90%;
  height: 1.5em;
}

.page-btn {
  border-radius: 5px;
  border: 0px;
  background-color: #5dabbe;
  margin: 10px;
  padding: 10em;
  font-weight: 400;
  text-align: center;
  text-decoration: none;
  color: #cbe7e5;
  font-size: 1.0em;
  user-select: none;
  width: 90%;
  height: 1.5em;
}

.key-pad {
  background-color: #afdfdf;
  width: 250px;
  height: 270px;
  padding: 10px 10px;
  font-size: 12pt;
}
/*
.num-btn {
    font-size: 2.0em;
}
.num-btn-flex {
    padding: 5px 10px;
    margin: 1px 1px;
    line-height: 1.0em;
}
.clear-btn {
  font-size: 2.44em;
  padding:16px 30px 7px;
}
.num-btn-0 {
    padding: 7px 30px -5px;
    margin: 0px 1px 0px;
    line-height: 64px;
}
.clr-btn {
    font-size: 3em;
    font-weight: 400;
    padding: 10px 27px 5px;
    margin: 20px 1px;
    line-height: 64px;
}
*/
</style>